import React from 'react'
import Carousel from 'react-material-ui-carousel'
import cp1 from "./../../images/cp1.png"
import cp2 from "./../../images/cp2.png"

import { Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';


//import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
//import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';


export const CorporateCarousel = (props) => {
  var items = [
    {
        src: cp1,
        txt: "corporate photo1",
        rvw: `THIS IS FANTASTIC - I took my commercial banking team over for a 
        couple of sessions for a fun afternoon. I have to say that this exceeded
         all expectations for fun and a great team building activity. They have 
         the capacity to work with groups and their staff was wonderful. If you
          are looking for something new for staff or just Friends and Family, 
          this is a great place to get a change of place that will blow your mind.
           My group ages ranged from 30 to 60 and everyone in the group was overwhelmed
            by the fun. #firstcitizensbank. #foreverfirst
        `,
        aut: `-- Greg M., First Citizens Bank`
    },
    {
        src: cp2,
        txt: "corporate photo2",
        rvw: `Did a team bonding activity with 10 girls who never touched VR devices in their lives.
         Many were scared it would give you motion sickness but we were totally fine. 
         We had to work together to solve the puzzles and get out of the room. 
         We highly enjoyed our time at Diablo Escapes and look forward to coming back soon!
        `,
        aut: `-- Marissa C., Levi Strauss & Co.`
    },
    
  ]
  return (
    <>
        <Carousel navButtonsAlwaysVisible={true} indicators={false} navButtonsWrapperProps={{   // Move the buttons to the bottom. Unsetting top here to override default style.
        style: {
            top:"-45%"
        }
    }} >
            {
                items.map( (item, i) => <Item key={i} item={item} /> )
            }
        </Carousel>
      
    </>
  )
}
function Item(props)
{
    return(
      <Box>
      <img src={props.item.src} alt={props.item.txt} style={{width:"100%", display:"block"}}/>
      <Paper style={{backgroundColor:"black"}}>
        <Typography color="white" fontFamily={"Sans-Serif"} variant="h6">
            {props.item.rvw} <br/><br/>
            {props.item.aut}
        </Typography>
      </Paper>
      </Box>
    )
}